import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "greyhixs",
    aws_cognito_region: "us-east-1",
    aws_cognito_identity_pool_id: "",
    aws_user_pools_id: "",
    aws_user_pools_web_client_id: "",
    Auth: {
      identityPoolId: "",
      region: "us-east-1",
      userPoolId: "",
      userPoolWebClientId: "",
    },
    oauth: {
      domain: `whs-eap-beta-na.auth.us-east-1.amazoncognito.com`,
      redirectSignIn: "https://greyhixs.na.safety-genie.whs.amazon.dev",
      redirectSignOut: "https://greyhixs.na.safety-genie.whs.amazon.dev",
      scope: ["openid", "email", "profile"],
      responseType: "code",
    },
  };
  Auth.configure(config);
}
